// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const DIV_CX = 'display-flex align-items-center flex-direction-column justify-content-center';

export default class LoadingDiv extends Component {
  static propTypes = {
    progress: PropTypes.number,
    progressRate: PropTypes.number
  };

  static defaultProps = {
    progress: null,
    progressRate: 400
  };

  render() {
    const { className, style } = this.props;

    return (
      <div className={cx(DIV_CX, className)} style={style}>
        <div className="loader">Loading...</div>
      </div>
    );
  }
}